import styled from '@emotion/styled';

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  justify-content: space-between;
`;
